import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { v4 as uuid } from 'uuid';

export function createUUID() {
  return uuid()
}

export function getISODateFromDate (date: Date): string {
  const adjDate = new Date(date)
  // Adjust by time zone offset to make sure the date string doesn't shift
  adjDate.setMinutes(-adjDate.getTimezoneOffset())
  return adjDate.toISOString().substr(0, 10)
}

export function getISODateTimeFromDate(date: Date) : string {
  return date.toISOString()
}

export function getISODateToday() : string {
  const date = new Date()
  return getISODateFromDate(date)
}

export function getISODateTime() : string {
  const date = new Date()
  return date.toISOString()
}

// export function getExpireDate(minutes: number) : string {
//   const date = new Date()
//   const expireDate = addMinutes(date, minutes)
//   return getISODateTimeFromDate(expireDate)
// }
//
export function isoToLocalDate(isoDate: string) {
  const date = new Date(isoDate)
  date.setMinutes(date.getTimezoneOffset())
  return date
}

export function isoToLocalDateTime(isoDateTime: string) {
  const date = new Date(isoDateTime)
  return date
}

export function secondsToDuration(input: number) {
  let result = ""
  if (input <= 0) {
    result = "0:00"
  } else {
    // const time = addSeconds(new Date(0), seconds)
    let hours = 0
    let minutes = 0
    let seconds = 0
    let remaining = input
    if (remaining >= 3600) {
      hours = Math.floor(remaining / 3600)
      remaining = remaining % 3600
    }
    if (remaining >= 60) {
      minutes = Math.floor(remaining / 60)
      remaining = remaining % 60
    }
    seconds = remaining

    if (hours > 0) {
      result = `${hours}:`
    }
    result = `${result}${pad(minutes, hours > 0 ? 2 : 1)}:${pad(seconds,2)}`
  }
  return result
}

export function pad(num: number, size: number) {
  let padded = num.toString();
  while (padded.length < size) padded = "0" + padded;
  return padded;
}

export function durationToSeconds(duration: string) : number {
  const parts = duration.split(':')
  let hours = "0"
  let minutes = "0"
  let seconds = "0"
  if (parts.length >= 3) {
    hours = parts[0]
    minutes = parts[1]
    seconds = parts[2]
  } else if (parts.length === 2) {
    minutes = parts[0]
    seconds = parts[1]
  } else if (parts.length === 1) {
    seconds = parts[0]
  }
  return (+hours) * 60 * 60 + (+minutes) * 60 + (+seconds);
}

export function getErrorMessage(err: any) {
  if (err.response && err.response.data && err.response.data.details && err.response.data.details.raw && err.response.data.details.raw.message) {
    return err.response.data.details.raw.message
  } else if (err.response && err.response.data && err.response.data.message) {
    return err.response.data.message
  } else if (err.message) {
    return err.message
  } else {
    return "Unknown error"
  }
}

export function timestampToISOString(timestamp: number): string {
  if (timestamp) {
    const date = new Date(timestamp*1000)
    return date.toISOString()
  } else {
    return ""
  }
}

export function undefineEmptyStrings(map: object) {
  Object.keys(map).forEach(key => {
    const value = map[key]
    if (typeof value === "string" && value.length === 0) {
      map[key] = undefined
    }
  })
}

export function phoneToE164Format(phone: string): string | null {
  const phoneNumber = parsePhoneNumberFromString(phone, "US")
  if (phoneNumber && phoneNumber.isValid()) {
    return phoneNumber.number.toString()
  } else {
    return null
  }
}

export function phoneToNationalFormat(phone: string): string {
  if (!phone) {
    return ""
  }
  const phoneNumber = parsePhoneNumberFromString(phone, "US")
  if (phoneNumber && phoneNumber.isValid()) {
    return phoneNumber.formatNational()
  } else {
    return phone
  }
}

export function numberToMoneyFormat(value: number) : string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  if (value === -0.00) {
    value = 0.00
  }
  return formatter.format(value)
}

export function humanizeString (input: string): string {
  if (typeof input !== 'string') {
    throw new TypeError('Expected a string');
  }

  input = decamelize(input, ' ');
  input = titleCase(input)

  return input;
}

export function decamelize(text: string, separator: string = '_'): string {
  return text
    .replace(/([a-z\d])([A-Z])/gu, `$1${separator}$2`)
    .replace(/([A-Z]+)([A-Z][a-z]+)/gu, `$1${separator}$2`)
    .toLowerCase();
}

export function titleCase(str: string): string {
  return str.toLowerCase().split(' ').map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}
